import { getWebApp } from '../telegram/telegram';
import { useAuthStore } from '../store/authStore';

// Shown when the backend returns telegram_contact_required: the rider opened the
// Mini App but has not shared their phone with the bot yet. We send them back to
// the bot chat to tap "Поділитися номером", then retry sign-in.
export function NeedsContactScreen() {
  const signIn = useAuthStore((s) => s.signIn);

  const openBot = () => {
    const wa = getWebApp();
    // Closing returns the user to the bot chat where the contact button lives.
    wa?.close();
  };

  return (
    <div className="centered-screen">
      <div className="brand">Carma</div>
      <p className="muted">
        Щоб замовити поїздку, поділіться номером телефону з ботом — натисніть кнопку
        «Поділитися номером» у чаті.
      </p>
      <button className="primary-button" onClick={openBot}>
        Відкрити чат з ботом
      </button>
      <button className="link-button" onClick={() => signIn()}>
        Я вже поділився — повторити
      </button>
    </div>
  );
}
